import { render, staticRenderFns } from "./NavbarCustomer.vue?vue&type=template&id=a80fceda&scoped=true&"
import script from "./NavbarCustomer.vue?vue&type=script&lang=js&"
export * from "./NavbarCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NavbarCustomer.vue?vue&type=style&index=0&id=a80fceda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80fceda",
  null
  
)

export default component.exports